import { makeStyles } from '@material-ui/core';

export const useDateInputStyles = makeStyles(theme => ({
  root: {
    '& .rdtPicker': {
      marginTop: 10,
    },
  },
}));
